/** Constants used across the UI of Perf. */ /** MISSING_DATA_SENTINEL is the value the backend uses to indicate that a
 *  sample is missing from a trace. This must be set to the same value as the
 *  const MissingDataSentinel in //go/vec32/vec.
 *
 *  JSON doesn't support NaN or +/- Inf, so we need a valid float32 to signal
 *  missing data that also has a compact JSON representation.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MISSING_DATA_SENTINEL: function() {
        return MISSING_DATA_SENTINEL;
    },
    MISSING_VALUE_SENTINEL: function() {
        return MISSING_VALUE_SENTINEL;
    },
    UNSET_TIME: function() {
        return UNSET_TIME;
    }
});
const MISSING_DATA_SENTINEL = 1e32;
const MISSING_VALUE_SENTINEL = '__missing__';
const UNSET_TIME = -1;
